/** @flow */

import React from "react";
import classNames from "classnames";
import "./icons.style.scss";

type Props = $Exact<{
  color?: string,
  className?: string,
  onClick?: (event: SyntheticEvent<HTMLButtonElement>) => void,
}>;

const ChartDynamicIcon = (props: Props) => (
  <svg
    className={classNames("icons", props.color, props.className, {
      charcoal: !props.color,
    })}
    onClick={props.onClick}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
  >
    <g id="chart-dynamic-icon">
      <path d="M0.5,23.5 L23.5,23.5" />
      <rect x="1.5" y="18.5" width="3" height="5" />
      <rect x="7.5" y="13.5" width="3" height="10" />
      <rect x="13.5" y="15.5" width="3" height="8" />
      <rect x="19.5" y="8.5" width="3" height="15" />
      <circle cx="3" cy="11.5" r="1" />
      <circle cx="9" cy="6.5" r="1" />
      <circle cx="15" cy="8.5" r="1" />
      <circle cx="21" cy="1.5" r="1" />
      <path d="M3.769,10.86 L8.232,7.139" />
      <path d="M9.945,6.815 L14.08,8.193" />
      <path d="M20.35,2.258 L15.65,7.74" />
    </g>
  </svg>
);

export default ChartDynamicIcon;
